export const ChatContainerStyles = {
	margin: '0 auto',
	position: 'relative',
	zIndex: 2,
	width: '100%',
	maxWidth: '690px',
	height: '100vh',
	overflow: 'hidden',
};

export const PageTitleStyle = {
	color: '#212121',
	textAlign: 'center',
	fontSize: '32px',
	fontStyle: 'normal',
	fontWeight: 700,
	lineHeight: 'normal',
};

export const PageTitleStyleVariant = {
	fontWeight: 'normal',
};

export const PageBackgroundStyle = {
	backgroundColor: '#F9FFFF',
	position: 'fixed',
	top: 0,
	left: 0,
	width: '100vw',
	height: '100vh',
	zIndex: 1,
};

export const ContainerStyle = {
	position: 'fixed',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	zIndex: 2,
	width: '100%',
	maxWidth: '690px',
};

export const SmallPrintStyle = {
	maxWidth: '500px',
	margin: '0 auto',
	textAlign: 'center',
	color: '#1E1E1E',
	fontSize: '10px',
	fontStyle: 'normal',
	fontWeight: 'normal',
	lineHeight: 'normal',
	padding: '0 16px',
	'& a': {
		color: '#1E1E1E',
		textDecoration: 'none',
		fontWeight: 700,
		'&:hover': {
			textDecoration: 'underline'
		}
	}
};

export const SmallPrintStyleAtIntro = {
	...SmallPrintStyle,
	animationDelay: '2s',
};

export const userInputStyle = {
	color: '#212121',
	fontSize: '24px',
	fontStyle: 'normal',
	fontWeight: 700,
	lineHeight: 'normal',
};

export default {
	PageBackgroundStyle,
	ChatContainerStyles,
	PageTitleStyleVariant,
	PageTitleStyle,
	SmallPrintStyle,
	userInputStyle,
};